export enum PathologyType {
  Demence,
  Cardio,
  Neuro,
  Pneumo,
  rhumato,
  gastroenterologie,
  ophtalmologie,
  infectieux,
  endocrinologie,
  vasculaire,
  traumatologie,
  psychiatrique,
  cancerologie,
  dermatologie,
  urologie,
  néphrologie,
  Chirurgicaux,
  hématologie,
  gynecologie,
  Démence,
  autres,
  Aucun
}
